import { render, staticRenderFns } from "./UsernameFurtherAssistance.vue?vue&type=template&id=0b590032&scoped=true&"
import script from "./UsernameFurtherAssistance.vue?vue&type=script&lang=js&"
export * from "./UsernameFurtherAssistance.vue?vue&type=script&lang=js&"
import style0 from "./UsernameFurtherAssistance.vue?vue&type=style&index=0&id=0b590032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b590032",
  null
  
)

export default component.exports